import { render } from "./StickerPackage.vue?vue&type=template&id=327161a0&scoped=true"
import script from "./StickerPackage.vue?vue&type=script&lang=js"
export * from "./StickerPackage.vue?vue&type=script&lang=js"

import "./StickerPackage.vue?vue&type=style&index=0&id=327161a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-327161a0"]])

export default __exports__